


















































































































































































































































































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import {
  BUSSINESS,
  BUSSINESS_SUBJECTS,
  SENSITIVE_WORD_TYPE,
  SENSITIVE_WORDS,
  USER_GROUPS
} from '../../../service/constant'
import {
  batchTerminate,
  getCurrentUserInfo,
  getSubTask,
  getTaskList,
  queryGroupUser,
  queryUserListWithGroup,
  retrieveTask,
  batchTransfer
} from '../../../service/manage'
import { getTaskInstance } from '../../../service/platform'
import { STAGES } from '../../../service/platform'
import ViewAuditHistory from '../../platform/components/ViewAuditHistory.vue'
import { TaskInstance } from '../../platform/types/task'
import { ALL_GROUPS, FORM_ITEM_LAYOUT, PROCESS_TYPES } from '../config/'
import {
  subTaskInProcessColumns,
  subTaskInProcessColumns_JZDX,
  taskInProcessColumns
} from '../config/columns'
import { column, option } from '../interface/'

@Component({ components: { ViewAuditHistory } })
export default class TaskQuery extends Vue {
  private get groups() {
    return this.$store.state[USER_GROUPS]
  }
  private get business() {
    return this.$store.state[BUSSINESS]
  }
  private get sensitives() {
    return this.$store.state[SENSITIVE_WORD_TYPE] // 默认使用敏感词的
  }
  private get subjects() {
    if (!this.taskForm.business_type) return []
    const dict = this.$store.state[BUSSINESS_SUBJECTS]
    return dict[this.taskForm.business_type] || []
  }
  // 家长大学 和 一起学运营图片审核
  public get taskForm_process_type_Options(): { label: string; value: string }[] {
    if (this.taskForm.business_type == '6001' && this.taskForm.subject_id == '801') {
      return [{ label: '快捷审核', value: 'process_000000006426' }]
    } else if (this.taskForm.business_type == '6002' && this.taskForm.subject_id == '802') {
      return [{ label: '快捷审核', value: 'process_000000006426' }]
    } else if (this.taskForm.business_type == '7001') {
      return [
        { label: '不限', value: '' },
        { label: '一级审核', value: 'process_000000010898' },
        { label: '二级审核', value: 'process_000000011746' }
      ]
    } else {
      return [
        { label: '不限', value: '' },
        { label: '一级审核', value: 'process_000000003973' },
        { label: '二级审核', value: 'process_000000004160' }
      ]
    }
  }
  public get subTaskInProcessColumns(): column[] {
    if (this.currentParentTask.business_type == '家长大学') {
      return subTaskInProcessColumns_JZDX
    } else {
      return subTaskInProcessColumns
    }
  }
  // 家长大学 end

  public selectedSubRowKeys: any[] = []
  public subTaskList = []
  public isAbortButtonDisabled = true
  public isSubAbortButtonDisabled = true
  public formItemLayout = FORM_ITEM_LAYOUT
  public isSubViewVisible = false

  public userList: any[] = []
  public currentUserId = ''
  public isAdmin = false
  // 父任务
  public taskInProcessColumns: column[] = taskInProcessColumns
  public taskInProcessDataSource: any[] = []
  public taskForm = {
    resource_id: '',
    task_id: '',
    task_name: '',
    business_type: '',
    subject_id: '',
    process_type: '',
    user_id: '',
    range: ['', '']
  }
  public selectedRowKeys = []
  public selectedRows = []
  public taskInProcessPagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showTotal: (total) => `共 ${total} 条`
  }
  public processTypes = []
  public reviewer: any[] = []
  handleUserSearch(value) {
    this.renderReviewerList(value)
  }
  // 子任务
  public currentParentTask: any = {}
  public subTaskDataSource: any[] = []
  public subTaskRangeValue = []
  public defaultSubTaskFormValue = {
    process_type: '',
    resource_id: '',
    sample_type: '',
    sensitive_type: '',
    range: '',
    tag: '',
    status: ''
  }
  public subTaskForm = {
    process_type: '',
    resource_id: '',
    sample_type: '',
    sensitive_type: '',
    range: '',
    tag: '',
    status: ''
  }
  public subTaskPagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showTotal: (total) => `共 ${total} 条`
  }
  private subInstanceData: TaskInstance | {} = {} // 查看审核信息-实例数据
  private showAuditHistory = false // 是否显示审核信息modal
  private customStyle =
    'background: rgba(255,255,255,0);border-radius: 4px;border: 0;overflow: hidden;'
  @Watch('taskForm_process_type_Options')
  public onTaskForm_process_type_OptionsChange() {
    this.taskForm.process_type = this.taskForm_process_type_Options[0].value
  }
  public onSelectChange(selectedRowKeys, selectedRows) {
    let arr = [STAGES.STAGE1[1], STAGES.STAGE2[1]]
    this.selectedRowKeys = selectedRowKeys
    this.selectedRows = selectedRows.map((item) => {
      return item.task_id
    })
    // 判断所选项中是否有二审id，如果有二审id就使用二审id，如果没有使用一审id ---- 广告
    if (this.currentBusinessType != '7001') return
    let selectTypes = selectedRows.map((item) => {
      return item.process_id
    })
    selectTypes = [...new Set(selectTypes)]
    if (
      selectTypes.find((item) => {
        return item === STAGES.STAGE2[1]
      })
    ) {
      this.currentProcessType = STAGES.STAGE2[1]
    } else {
      this.currentProcessType = STAGES.STAGE1[1]
    }
  }
  public onSubSelectChange(selectedRowKeys, selectedRows) {
    this.selectedSubRowKeys = selectedRowKeys
    this.subTaskList = selectedRows.map((item) => item.instance_id)
  }
  @Watch('taskForm.business_type')
  public onBussinessChange(val) {
    if (!this.subjects || this.subjects.length == 0) return
    if (!this.subjects.map((item) => item.value).includes(this.taskForm.subject_id)) {
      setTimeout(() => {
        this.taskForm.subject_id = this.subjects[0].value
      })
    }
  }
  @Watch('selectedRowKeys')
  public onSelectedRowKeysChange(newVal, oldVal) {
    this.isAbortButtonDisabled = newVal.length === 0
  }
  @Watch('selectedSubRowKeys')
  public onSelectedSubRowKeysChange(newVal, oldVal) {
    this.isSubAbortButtonDisabled = newVal.length === 0
  }
  public async mounted() {
    if (this.groups.includes(ALL_GROUPS[3].id)) {
      this.isAdmin = true
    }
    this.taskForm.business_type = this.business[0].value
    const res = await getCurrentUserInfo()
    this.currentUserId = res.id
    await this.renderReviewerList('')
    await this.renderTaskInProcess(1)
  }
  public onTaskRangeChange(date, dateString) {
    this.taskForm.range = dateString
  }
  public handleTaskFormSubmit(e) {
    this.renderTaskInProcess(1)
  }
  public handleInProcessTableChange(pagination) {
    this.renderTaskInProcess(pagination.current)
  }
  public abortTask(e) {
    const self = this
    this.$confirm({
      title: '任务终止',
      content: '是否确定终止任务？',
      async onOk() {
        const options = {
          user_id: self.currentUserId,
          instance_ids: self.selectedRows,
          reason: ''
        }
        const query = self.$route.query
        const url = query.tab ? window.location.href : `${window.location.href}?tab=2`
        await batchTerminate(options)

        self.selectedRows = []
        self.selectedRowKeys = []
        self.renderTaskInProcess(1)
      }
    })
  }
  public async renderTaskInProcess(page_num) {
    const options = {
      resource_id: this.taskForm.resource_id,
      subject_id: Number(this.taskForm.subject_id),
      process_type: this.taskForm.process_type,
      start_at: this.taskForm.range[0],
      end_at: this.taskForm.range[1],
      task_id: this.taskForm.task_id,
      business_type: Number(this.taskForm.business_type),
      task_name: this.taskForm.task_name,
      user_id: this.taskForm.user_id,
      page_num,
      page_size: 10
    }
    const { list, total } = await getTaskList(options)
    this.taskInProcessDataSource = list
    this.taskInProcessPagination.total = total
    this.taskInProcessPagination.current = page_num
    // 用于记录点击查询后下次点击查询前这段时间列表中的business_type , process_type
    this.currentBusinessType = options.business_type
    // this.currentProcessType = options.process_type
  }
  public async checkSubTask(text, record) {
    this.renderSubTaskProcess(record.process_id)
    await this.renderSubTaskList(text, 1)
    this.isSubViewVisible = true
    this.currentParentTask = record
  }
  public renderSubTaskProcess(id) {
    this.processTypes = PROCESS_TYPES[id]
  }
  public backToParent(e) {
    this.isSubViewVisible = false
    this.subTaskForm = { ...this.defaultSubTaskFormValue }
    this.subTaskRangeValue = []
    // 返回清除选中项
    this.selectedSubRowKeys = []
    this.subTaskList = []
  }
  public async renderReviewerList(username) {
    const options = {
      status: this.taskForm.process_type,
      username
    }
    this.reviewer = await queryGroupUser(options)
  }
  public onSubTaskRangeChange(date, dateString) {
    this.subTaskForm.range = dateString
  }
  public async handleSubTaskFormSubmit(e) {
    const parent_id = this.currentParentTask.task_id
    await this.renderSubTaskList(parent_id, 1)
  }
  public async abortSubTask(e) {
    const self = this
    this.$confirm({
      title: '任务终止',
      content: '是否确定终止任务？',
      async onOk() {
        const options = {
          user_id: self.currentUserId,
          instance_ids: self.subTaskList,
          reason: ''
        }
        await batchTerminate(options)
        const parent_id = self.currentParentTask.task_id
        self.subTaskDataSource = []
        self.selectedSubRowKeys = []
        self.subTaskList = []
        await self.renderSubTaskList(parent_id, 1)
        if (self.subTaskDataSource.length === 0) {
          window.location.reload()
        }
      }
    })
  }
  public async renderSubTaskList(parent_id: string, page_num) {
    const options = {
      parent_id,
      page_num,
      resource_id: this.subTaskForm.resource_id,
      sample_type: Number(this.subTaskForm.sample_type),
      sensitive_type: Number(this.subTaskForm.sensitive_type),
      only_finished: 0,
      page_size: 10,
      check_at: '',
      check_end: '',
      tag: this.subTaskForm.tag,
      process_type: this.subTaskForm.process_type
    }
    const { list, total } = await getSubTask(options)
    this.subTaskDataSource = list
    this.subTaskPagination.total = total
    this.subTaskPagination.current = page_num
    list.forEach((item: any) => console.log(item.back))
  }
  public async handleSubTaskTableChange(pagination) {
    const parent_id = this.currentParentTask.task_id
    await this.renderSubTaskList(parent_id, pagination.current)
  }
  // 撤回任务
  public async retrieveSubTask(key, instance_id, record) {
    const subTaskDataSource = [...this.subTaskDataSource]
    this.subTaskDataSource[Number(key) - 1].hasRetrieved = true
    const user_id = this.currentUserId
    const options = {
      user_id,
      instance_id
    }
    await retrieveTask(options)
    const parent_id = this.currentParentTask.task_id
    await this.renderSubTaskList(parent_id, 1)
  }
  public async checkHistory(record: any) {
    let instance = (await getTaskInstance(record.instance_id)) as TaskInstance
    if (!instance || !instance.id) return

    this.subInstanceData = instance
    this.showAuditHistory = true
  }
  // 任务转办（广告）
  public listVisible = false
  public handlerUserId = ''
  public flowerList = []
  public currentBusinessType: any = ''
  public currentProcessType: any = ''
  public showListModal() {
    this.renderFlowerList()
    this.listVisible = true
  }
  public async handleListModalOk() {
    let result: any = await batchTransfer({
      transfer_to_user_id: this.handlerUserId || '',
      instance_ids: this.selectedRows
    })
    if (result.success) {
      const str = `成功转办：${this.selectedRows.join('，')}`
      this.$message.success(str)
    } else {
      if (result.error_list && result.error_list.length) {
        const str = `${
          result.success_hint ? result.success_hint + ' \r\n ' : ''
        } ${result.error_list.join(' \r\n ')}`
        this.$message.warning(str, 5)
      } else {
        if (result.error || result.msg) {
          this.$message.error(result.error || result.msg)
        }
      }
    }
    // 成功流转之后关闭窗口
    this.listVisible = false
    // 刷新界面
    this.renderTaskInProcess(1)
  }
  public handleListModalCancel() {
    this.listVisible = false
    // reset
    this.handlerUserId = ''
  }
  // 获取可流转人员名单 当一审，二审都有的情况默认使用更高级的,使用广告二审id,当只有一审id的时候，使用一审id
  public async renderFlowerList() {
    const options = {
      status: '',
      process_id: this.currentProcessType
    }
    this.flowerList = await queryGroupUser(options)
  }
  public filterOption(input, option) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }

  openResource(tag) {
    const { name, location } = tag
    let url = ''
    const arr = name.split('.')
    if (arr.length <= 1) return
    const suffix = arr[arr.length - 1]
    url = ['doc', 'docx'].includes(suffix)
      ? `https://vip.ow365.cn?i=22595&ssl=1&del=1&furl=${location}`
      : location
    window.open(url)
  }
}
